export const iconFontAwesomeConstructionTarp = (
	<i className="fa-solid fa-tarp"></i>
);
